module.exports = __webpack_public_path__ + "img/svg/email.e6ad724163692d87984bb38b71d86926.svg";